import React from "react";
import {
  Button,
  Empty,
  InputNumber,
  List,
  Popconfirm,
  Select,
  Typography,
} from "antd";

const HQOutboundScanner = ({
  outboundItems,
  locations,
  destination,
  onDestinationChange,
  onChangeQty,
  onRemove,
  onClear,
  onConfirm,
  loading,
  hqBranchId,
}) => {
  const items = Object.values(outboundItems || {});
  const totalQty = items.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0
  );
  const branchOptions = (locations || [])
    .filter((location) => location.id !== hqBranchId)
    .map((location) => ({
      value: location.id,
      label: location.name,
    }));

  return (
    <div className="hqInbound">
      <div className="hqInboundHeader">
        <Typography.Text strong>HQ Outbound Items</Typography.Text>
        <Typography.Text type="secondary">
          {items.length} products / {totalQty.toFixed(2)} total qty
        </Typography.Text>
      </div>

      <Select
        value={destination || undefined}
        placeholder="Select branch"
        options={branchOptions}
        onChange={onDestinationChange}
        style={{ width: "100%", marginBottom: "0.75em" }}
        showSearch
        optionFilterProp="label"
      />

      <List
        locale={{
          emptyText: (
            <Empty description="Select a branch, then scan product QR codes or barcodes" />
          ),
        }}
        dataSource={items}
        renderItem={(item) => (
          <List.Item
            actions={[
              <InputNumber
                key="qty"
                min={0}
                value={item.quantity}
                onChange={(value) => {
                  onChangeQty(item.id, value);
                }}
              />,
              <Popconfirm
                key="remove"
                title="Remove item?"
                onConfirm={() => {
                  onRemove(item.id);
                }}
              >
                <Button type="link" danger>
                  Remove
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              avatar={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                  alt={item.product_name}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: "contain",
                    borderRadius: 4,
                    background: "#fff",
                  }}
                />
              }
              title={item.product_name}
              description={item.unit || "unit"}
            />
          </List.Item>
        )}
      />

      <div className="hqInboundActions">
        <Button onClick={onClear}>Clear</Button>
        <Button type="primary" loading={loading} onClick={onConfirm}>
          Create Package
        </Button>
      </div>
    </div>
  );
};

export default HQOutboundScanner;
